'use strict';

const clamp = (min, max, v) => {
    if (v > max)
        return max;
    if (v < min)
        return min;
    return v;
};

exports.clamp = clamp;
//# sourceMappingURL=clamp.cjs.map
